import { requiresAuth } from "@/middleware";

const SignOutView = () => import("./SignOutView.vue");

const signOutRoutes = [
  {
    path: "/signout",
    name: "SignOut",
    component: SignOutView,
    meta: {
      middleware: requiresAuth
    }
  }
];

export default signOutRoutes;
